import VideoServiceBase_1 from '../../node_modules/markdown-it-block-embed/lib/services/VideoServiceBase.js';
import { canUseDOM, waitForElement } from '../../utils/markdown.plugin.utils.js';

/**
 * Element IDs need to be unique.
 * This helper method attaches a randomly generated string
 * to the end of the supplied prefix.
 *
 * @param {String} prefix ID prefix
 * @returns Element ID with random string appended to end.
 */
function getRandomElementId(prefix) {
  return Math.random().toString(36).replace('0.', prefix || '');
}
function getSourceType(videoID) {
  const fileTypeStart = videoID.lastIndexOf('.') + 1;
  const fileType = videoID.substring(fileTypeStart, videoID.length);

  // m3u8 videos need a special src type
  if (fileType === 'm3u8') return 'application/x-mpegURL';
  // all other videos will be type video/FILETYPE
  return "video/".concat(fileType);
}

// CustomVideoService is tested in BlockEmbed.test.js
class CustomVideoService extends VideoServiceBase_1 {
  getVideoUrl(videoID) {
    return this.env.md.utils.escapeHtml(videoID);
  }
  getEmbedCode(videoID) {
    if (!canUseDOM) return;
    const divEl = document.createElement('div');
    const videoEl = document.createElement('video');
    const videoElID = getRandomElementId('video_js_');
    const containerClassNames = [];
    if (this.env.options.containerClassName) {
      containerClassNames.push(this.env.options.containerClassName);
    }
    const escapedServiceName = this.env.md.utils.escapeHtml(this.name);
    containerClassNames.push(this.env.options.serviceClassPrefix + escapedServiceName);

    // Set various element attributes
    divEl.className = containerClassNames.join(' ');
    videoEl.id = videoElID;
    videoEl.className = 'video-js vjs-big-play-centered';
    videoEl.setAttribute('controls', true);
    if (this.env.options.outputPlayerSize === true) {
      if (this.options.width !== undefined && this.options.width !== null) {
        videoEl.setAttribute('width', this.options.width);
      }
      if (this.options.height !== undefined && this.options.height !== null) {
        videoEl.setAttribute('height', this.options.height);
      }
    }
    divEl.appendChild(videoEl);

    // wait for video element to exist then load video.js resources
    waitForElement(window, videoElID).then(() => {
      // Dynamically loading video.js to optimize loading
      import('video.js').then(videojs => {
        // CSS needs to be manually imported for video.js
        import('../../node_modules/video.js/dist/video-js.min.css.js');
        // check if element unmounted
        if (!window.document.getElementById(videoElID)) return;
        const player = videojs.default(videoElID, {
          playbackRates: [1, 1.25, 1.5, 1.75, 2]
        });
        player.src({
          src: this.getFilteredVideoUrl(videoID),
          type: getSourceType(videoID)
        });
      });
    });
    return divEl.outerHTML;
  }
}
var CustomVideoService$1 = CustomVideoService;

export { CustomVideoService$1 as default };
